import i18next from 'i18next';
import { ModifiedArray } from 'infrastructure/classes/common/modified-array';

export interface IClinicReviewTimeItem {
  id: number | null;
  name: string;
}

type ClinicReviewTimeArray = ModifiedArray<IClinicReviewTimeItem>;

export const clinicReviewTimesDataSource = (
  withAll = false,
): ClinicReviewTimeArray => {
  const dataSource = new ModifiedArray<IClinicReviewTimeItem>(
    ...Array.from({ length: 10 }, (_, i) => {
      const minute = i + 1;
      const seconds = minute * 60;
      const label =
        minute > 1 ? i18next.t('labels.minutes') : i18next.t('labels.minute');
      return {
        id: seconds,
        name: `${minute} ${label}`,
      };
    }),
  );

  if (withAll) {
    dataSource.unshift({
      id: null,
      name: i18next.t('labels.all'),
    });
  }

  return dataSource;
};
